import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import store from "./features/store";
import App from "./App";
import Home from "./pages/home/Home";
import VerificationPending from "./pages/verificationPending/VerificationPending";
import EmailVerification from "./pages/emailVerification/EmailVerification";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Connect from "./pages/connect/Connect";
import Member from "./pages/member/Member";
import Freezer from "./components/freezer/Freezer";
import PrivateRoute from "./components/privateRoute/PrivateRoute";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import "./main.scss";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: "verify-email/:token",
          element: <EmailVerification />,
        },
        {
          path: "reset-password/:token",
          element: <ResetPassword />,
        },
        {
          path: "verify-email",
          element: <VerificationPending />,
        },
        {
          path: "forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "connect",
          element: <Connect />,
        },
        {
          path: "home",
          element: (
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          ),
        },
        {
          path: "freezer",
          element: (
            <PrivateRoute>
              <Freezer />
            </PrivateRoute>
          ),
        },
        {
          path: "member",
          element: (
            <PrivateRoute>
              <Member />
            </PrivateRoute>
          ),
        },
        {
          path: "*",
          element: <ErrorBoundary />,
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_startTransition: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
      v7_skipHydrationWarning: true,
      v7_prependBasename: true,
    },
  }
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);
